import SupportTicketsIndex from '../laisSupport/pages/SupportTicketsIndex.vue';
import { laisPath } from '../laisRouteHelpers';

export default {
  path: laisPath('atendimento-online'),
  component: SupportTicketsIndex,
};
